type T = {
    id: number,
}

export default (participants: T[], ids: number[]) => participants.filter(
    value => ids.includes(+value.id),
);
